import { useFeatureFlag } from '@artic/ui/feature-flags';
import { FullHeightStack } from '@artic/ui/full-height-layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@artic/ui/tabs';
import { createFileRoute } from '@tanstack/react-router';
import { useQueryState } from 'nuqs';

import { ChangeControlWorkOrdersView } from '../../features/change-control/change-control-work-orders-view';
import { RunHistoryTable } from '../../features/change-control/run-history-table';
import {
  changeControlSearchParsers,
  type ChangeControlTab,
} from '../../features/change-control/search';
import { usePartnerId } from '../../features/inbox/use-partner-name';

export const Route = createFileRoute('/change_control/')({
  staticData: {
    breadcrumb: 'Change Control',
    layout: 'default',
  },
  component: ChangeControlPage,
});

function ChangeControlPage() {
  const enabled = useFeatureFlag('change_control');
  const partnerId = usePartnerId();
  const [tab, setTab] = useQueryState('tab', changeControlSearchParsers.tab);

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Change Control is not available</h2>
        <p className="text-muted-foreground text-sm">
          Change Control is not enabled for your organisation.
        </p>
      </div>
    );
  }

  return (
    <FullHeightStack className="gap-3">
      <header className="shrink-0">
        <h1 className="text-2xl font-semibold">Change Control</h1>
        <p className="text-muted-foreground text-sm">
          Work orders behind their current Run Sheet, and the history of releases.
        </p>
      </header>
      <Tabs
        value={tab}
        onValueChange={(v) => void setTab(v as ChangeControlTab)}
        className="flex min-h-0 flex-1 flex-col gap-3"
      >
        <TabsList className="shrink-0">
          <TabsTrigger value="work-orders">Work Orders</TabsTrigger>
          <TabsTrigger value="history">History</TabsTrigger>
        </TabsList>
        <TabsContent value="work-orders" className="flex min-h-0 flex-1 flex-col">
          <ChangeControlWorkOrdersView partnerId={partnerId} />
        </TabsContent>
        <TabsContent value="history" className="min-h-0 flex-1 overflow-y-auto">
          <RunHistoryTable partnerId={partnerId} />
        </TabsContent>
      </Tabs>
    </FullHeightStack>
  );
}
